import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
export function FinalCTA() {
  return <section className="py-20 bg-background relative overflow-hidden" data-id="element-73">
      <div className="absolute inset-0 z-0" data-id="element-74">
        <img src="https://images.unsplash.com/photo-1569263979104-865ab7cd8d13?q=80&w=1200&auto=format&fit=crop" alt="Luxury Yacht" className="w-full h-full object-cover opacity-10" data-id="element-75" />
        <div className="absolute inset-0 bg-gradient-to-t from-background via-background/80 to-background" data-id="element-76"></div>
      </div>

      <div className="px-5 relative z-10" data-id="element-77">
        <motion.div className="text-center space-y-6" initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-78">
          <h2 className="text-3xl font-bold text-white font-heading leading-tight" data-id="element-79">
            Tu experiencia ya vale{' '}
            <span className="text-primary" data-id="element-80">más de lo que pensás</span>
          </h2>

          <p className="text-base text-white/80 leading-relaxed" data-id="element-81">
            La única diferencia entre seguir donde estás y comenzar una carrera
            internacional puede ser conocer el camino correcto.
          </p>

          <div className="pt-4" data-id="element-82">
            <Button size="lg" asChild className="w-full text-base px-6 py-6 bg-primary hover:bg-primary/90 text-primary-foreground shadow-[0_0_50px_-10px_rgba(212,168,87,0.6)] active:scale-95 transition-all rounded-2xl font-bold" data-id="element-83">
              <a href="https://checkout.librofy.online/cart/53242880491883:1" target="_blank" rel="noopener noreferrer" data-id="element-84">
                👉 QUIERO EMPEZAR AHORA
              </a>
            </Button>
          </div>
        </motion.div>
      </div>
    </section>;
}